/**
 * TanStack Query options for the admin gate, GET /api/admin/me.
 *
 * This is the SINGLE server-side admin check for the whole admin feature — the
 * same `checkAdmin()` gate the real authz endpoints use. The page UI decision
 * routes through it so the chrome can't render for a non-admin (see
 * apps/experts/api/admin/me.js for why the client-side role read was a security
 * bug). Every admin page consumes this via the shared AdminGuard; there is NO
 * per-page MSAL or per-page admin check (rebuild-lessons.md #2).
 *
 * Follows the chat feature's separated query-factory convention; the call goes
 * through the vendored `api` wrapper → the auth resolver seam.
 */
import { api } from '@andavo/web-ui/api';
import type { AdminMe } from '../types';

export const adminMeQueries = {
  all: () => ['admin', 'me'] as const,
  /**
   * The gate query. `retry: false` so a non-admin / error answer is final and
   * the guard fails closed immediately rather than spinning. `staleTime` is
   * short so an admin grant/revoke takes effect on the next navigation without
   * a forced reload.
   */
  me: () => ({
    queryKey: adminMeQueries.all(),
    queryFn: () => api.get<AdminMe>('api/admin/me'),
    retry: false,
    staleTime: 30_000,
  }),
};
